import { LOCAL_STORAGE_KEYS } from '@constants';

export function setToken(value) {
  localStorage.setItem(LOCAL_STORAGE_KEYS.token, value);
}

export function clearToken() {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.token);
}

export function getToken() {
  try {
    return localStorage.getItem(LOCAL_STORAGE_KEYS.token);
  } catch (err) {
    clearToken();
    return null;
  }
}

export function setUser(value) {
  if (value) {
    localStorage.setItem(LOCAL_STORAGE_KEYS.user, JSON.stringify(value));
  }
}

export function clearUser() {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.user);
}

export function getUser() {
  try {
    let _user = localStorage.getItem(LOCAL_STORAGE_KEYS.user);
    return _user ? JSON.parse(_user) : null;

  } catch (err) {
    clearUser();
    return null;
  }
}

export function setUserPreferedLanguage(value) {
  localStorage.setItem(LOCAL_STORAGE_KEYS.userPreferedLanguage, value);
}

export function clearUserPreferedLanguage() {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.userPreferedLanguage);
}

export function getUserPreferedLanguage() {
  try {
    return localStorage.getItem(LOCAL_STORAGE_KEYS.userPreferedLanguage);
  } catch (err) {
    clearUserPreferedLanguage();
    return null;
  }
}

export function setExitGame(value) {
  localStorage.setItem(LOCAL_STORAGE_KEYS.exitGame, value);
}

export function getExitGame() {
  return localStorage.getItem(LOCAL_STORAGE_KEYS.exitGame);
}